<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'tag']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>{{ printName }}</v-list-tile-title>
      <v-list-tile-sub-title>{{ printKana }} &mdash; {{ printHep }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading" @click="edit">
          <font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon>
        </v-btn>
        <span>編集する</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
  <v-container v-else>
    <v-subheader>名前</v-subheader>
    <v-layout wrap class="pb-4">
      <v-flex xs12 sm6 class="px-3">
        <v-text-field label="姓" required
          v-model="form.name[0]"
          :rules="rules.name"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 class="px-3">
        <v-text-field label="名" required
          v-model="form.name[1]"
          :rules="rules.name"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 class="px-3">
        <v-text-field label="せい" required
          v-model="form.kana[0]"
          :rules="rules.kana"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 class="px-3">
        <v-text-field label="めい" required
          v-model="form.kana[1]"
          :rules="rules.kana"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 class="px-3">
        <v-text-field label="Last Name（姓）"
          v-model="form.hep[0]"
          :rules="rules.hep"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 class="px-3">
        <v-text-field label="First Name（名）"
          v-model="form.hep[1]"
          :rules="rules.hep"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicName',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        name: ['', ''],
        kana: ['', ''],
        hep: ['', '']
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ],
        hep: [
          v => !/[^A-z]/.test(v) || '英字のみ入力有効です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.name && this.$props.data.name.length &&
        this.$props.data.kana && this.$props.data.kana.length &&
        this.$props.data.hep
      ) {
        this.$set(this, 'form', {
          name: [
            this.$props.data.name.length > 0 ? this.$props.data.name[0] : '',
            this.$props.data.name.length > 1 ? this.$props.data.name[1] : ''
          ],
          kana: [
            this.$props.data.kana.length > 0 ? this.$props.data.kana[0] : '',
            this.$props.data.kana.length > 1 ? this.$props.data.kana[1] : ''
          ],
          hep: [
            this.$props.data.hep.length > 0 ? this.$props.data.hep[0] : '',
            this.$props.data.hep.length > 1 ? this.$props.data.hep[1] : ''
          ]
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'name'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['name', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'name'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['name', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'name'
      )
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name &&
        this.$props.data.name.length
      ) ? this.$props.data.name.join(' ') : ''
    },
    printKana () {
      return (
        this.$props.data &&
        this.$props.data.kana &&
        this.$props.data.kana.length
      ) ? this.$props.data.kana.join(' ') : ''
    },
    printHep () {
      return (
        this.$props.data &&
        this.$props.data.hep &&
        this.$props.data.hep.length
      ) ? this.$props.data.hep.join(' ') : ''
    }
  }
}
</script>
